const PremiumFeatures = {
  PREMIUM: 'PREMIUM',
}

export default PremiumFeatures
